module.exports = __webpack_public_path__ + "static/media/menu-dots.89d54325.svg";